import { Component } from '@angular/core';
import {VersionInfoComponent} from "../version-info/version-info.component";
import {RestService} from "../shared/rest/rest.service";

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss', '../version-info/version-info.component.scss']
})
export class AboutComponent extends VersionInfoComponent {

  constructor(rest:RestService) {
    super(rest)
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
